import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { DropdownType } from '@editor/src/js/constants/toolbar-data';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { TOOLBAR_DROPDOWN, TOOLBAR_ROWSPACING } from '@editor/src/img/pageIndex';
import { TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.ROW_SPACE,
    tipMsg: i18n.t('行间距'),
    icon: TOOLBAR_ROWSPACING,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.CUSTOM,
        checkSelectedValue: true,
        data: [
            {
                id: 1,
                icon: TOOLBAR_ROWSPACING,
                content: i18n.t('1倍行距'),
            },
            {
                id: 1.3,
                icon: TOOLBAR_ROWSPACING,
                content: i18n.t('1.3倍行距'),
            },
            {
                id: 1.5,
                icon: TOOLBAR_ROWSPACING,
                content: i18n.t('1.5倍行距'),
            },
            {
                id: 2,
                icon: TOOLBAR_ROWSPACING,
                content: i18n.t('2倍行距'),
            },
            {
                id: 2.5,
                icon: TOOLBAR_ROWSPACING,
                content: i18n.t('2.5倍行距'),
            },
            {
                id: 3,
                icon: TOOLBAR_ROWSPACING,
                content: i18n.t('3倍行距'),
            },
            {
                id: 'custom',
                icon: TOOLBAR_ROWSPACING,
                content: i18n.t('自定义行间距'),
            },
        ],
    },
    twdConfig: {
        action: TDWActionType.LINE_SPACING,
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        tooltip: config.tipMsg,
        hasArrow: true,
    },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: i18n.t<string>('行间距'),
        preventDismiss: true,
    },
    {
        name: config.id + 1,
        content: i18n.t<string>('1倍行距'),
    },
    {
        name: config.id + 2,
        content: i18n.t<string>('1.3倍行距'),
    },
    {
        name: config.id + 3,
        content: i18n.t<string>('1.5倍行距'),
    },
    {
        name: config.id + 4,
        content: i18n.t<string>('2倍行距'),
    },
    {
        name: config.id + 5,
        content: i18n.t<string>('2.5倍行距'),
    },
    {
        name: config.id + 6,
        content: i18n.t<string>('3倍行距'),
    },
    {
        name: ActionType.PARAGRAPH_MORE,
        content: i18n.t<string>('自定义行间距'),
    },
];
